export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES_BLANK.23719977.png";